import HeadTittle from "../../../components/HeadTittle";
import {permissionObj} from "../../../Helpers/permission";
import ButtonAction from "../../../components/buttons/ButtonAction";
import {AddIcon, TrashOutlineIconWhite,} from "../../../components/buttons/IconButtons";
import {ServiceTypeApp} from "./Funtionallity/ServiceTypeApp";
import SearchSimple from "../../../components/SearchSimples/SearchSimple";
import NotInformation from "../../../components/NotInformation";
import CustomExpandableTable from "../../../components/table/CustomExpandableTable";
import {CreateServiceType, UpdateServiceType} from "../../../reduxToolkit/ServiceType/ServiceTypeApi";
import CustomAddNewEntityModal from "../../../components/Modal/CustomAddNewEntityModal";
import React from "react";
import CustomButtonLink from "../../../components/buttons/CustomButtonLink";
import DeleteModal from "../../Modals/DeleteModal";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const ServiceType = () => {

    const{
        setAddShow,
        setIsUpdate,
        setDeleteServiceType,
        DEV,
        permission,
        addShow,
        isUpdate,
        updateData,
        deleteServiceType,
        deleteServiceTypeModal,
        searchElement,
        setSearchElement,
        setBodyForExport,
        setSearchResults,
        option,
        rowsPerPage,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        contractorId,
        supplierId,
        searchResults,
        handleCheckboxChange,
        pagination,
        t,
        handleDeleteAll,
        renderOptionsMenu,
        handleRowExpand,
        columns,
        selectedList,
        setSelectedList,
        searchId,
        renderExpandedRow,
        setModified,
        modified
    } = ServiceTypeApp();


    return (
        <>
            <HeadTittle name={'service_type'}>
                {(DEV || permission?.includes(permissionObj?.WEB_SERVICE_TYPE_CREATE)) && (
                    <ButtonAction
                        id='btn_st_add'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        onClick={() => {
                            setAddShow(true);
                            setIsUpdate(false);
                        }}
                    />
                )}
                {(DEV || permission?.includes(permissionObj?.WEB_SERVICE_TYPE_DELETE)) && (
                    <ButtonAction
                        id='btn_st_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectedList?.length === 0}
                        Icon={TrashOutlineIconWhite}
                        onClick={() => setDeleteServiceType(true)}
                    />
                )}
            </HeadTittle>

            <SearchSimple
                id={searchId}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                setBodyForExport={setBodyForExport}
                setSearchResults={setSearchResults}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={contractorId}
                supplierId={supplierId}
            />

            {searchResults?.content?.length > 0 ? (
                  <>
                      {/**Done*/}
                      <CustomExpandableTable
                          columns={columns}
                          rows={searchResults.content}
                          renderExpandedRow={renderExpandedRow}
                          renderOptionsMenu={(
                              DEV ||
                              permission?.includes(permissionObj.WEB_SERVICE_TYPE_UPDATE) ||
                              permission?.includes(permissionObj.WEB_SERVICE_TYPE_DELETE))  && (renderOptionsMenu)}
                          onRowExpand={handleRowExpand}
                          selectedList={selectedList}
                          handleCheckboxChange={handleCheckboxChange}
                          handleDeleteAll={handleDeleteAll}
                          rowsPerPage={rowsPerPage}
                      />
                      {pagination()}
                  </>
                ) : (

                    <NotInformation
                        card={true}
                    >
                        <>
                            <div className={"warning-text"}>
                                <p>{t("no_service_type_text")}</p>
                            </div>
                            {(DEV || permission?.includes(permissionObj?.WEB_SERVICE_TYPE_CREATE)) &&
                                <CustomButtonLink splitName={false} id={'btn_st_create'} card={true}
                                                  onClick={() => {setAddShow(true);setIsUpdate(false);}}
                                                  name={'created_service_type'}/>
                            }
                        </>
                    </NotInformation>
                )}

            <CustomAddNewEntityModal
                show={addShow}
                onHide={() => setAddShow(false)}
                title="service_type"
                createAction={CreateServiceType}
                updateAction={UpdateServiceType}
                isUpdate={isUpdate}
                data={updateData}
                setModified={setModified}
                modified={modified}
            />

            {deleteServiceType &&
                <DeleteModal
                    show={deleteServiceType}
                    onHide={() => setDeleteServiceType(false)}
                    data={selectedList}
                    onClickFn={() => {
                        deleteServiceTypeModal(selectedList);
                        setDeleteServiceType(false);
                    }}
                    title_modal='delete_service_type'
                    element_modal={t('service_type')}
                    isReset={setSelectedList}
                />
            }
        </>
    )
}

export default ServiceType
